export const msTeamsChatHref = (userPrincipalName: string | undefined) =>
  userPrincipalName
    ? `https://teams.microsoft.com/l/chat/0/0?users=${userPrincipalName}`
    : undefined;
